"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarLink = exports.SidebarLinkDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var link_controls_1 = require("../elements/link-controls");
var router_1 = require("@reach/router");
var use_sidebar_1 = require("../../hooks/use-sidebar");
exports.SidebarLinkDefaultProps = {
  controls: [],
  isActive: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    color: ", ";\n    font-weight: 500;\n    -webkit-user-select: none;  /* Chrome all / Safari all */\n    -moz-user-select: none;     /* Firefox all */\n    -ms-user-select: none;      /* IE 10+ */\n    user-select: none;          /* Likely future */     \n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: all 0.3s;\n    padding: ", " ", " ", " ", ";\n    ", "\n  "], ["\n    font-size: ", ";\n    display: flex;\n    color: ", ";\n    font-weight: 500;\n    -webkit-user-select: none;  /* Chrome all / Safari all */\n    -moz-user-select: none;     /* Firefox all */\n    -ms-user-select: none;      /* IE 10+ */\n    user-select: none;          /* Likely future */     \n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: all 0.3s;\n    padding: ", " ", " ", " ", ";\n    ", "\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('primary'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), function (_a) {
    var isActive = _a.isActive;
    return isActive && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme_1.theme.COLOR('light'));
  })
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: ", ";\n  "], ["\n    padding-left: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Controls: (0, styled_components_1.default)(link_controls_1.LinkControls)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
var SidebarLink = function (props) {
  var className = props.className,
    controls = props.controls,
    to = props.to,
    children = props.children,
    isActive = props.isActive;
  var sidebar = (0, use_sidebar_1.useSidebar)();
  var onClick = props.onClick || function () {
    sidebar.hideFloating();
    (0, router_1.navigate)(to);
  };
  return react_1.default.createElement(My.Container, {
    isActive: isActive,
    role: "button",
    onClick: onClick,
    className: className
  }, children, react_1.default.createElement(My.Controls, {
    items: controls
  }));
};
exports.SidebarLink = SidebarLink;
exports.SidebarLink.defaultProps = exports.SidebarLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;